import { PickupTaskState } from "../enums/tasks";
import { UserType } from "../enums/users";
import { User } from "../interfaces/common/authentication";
import { IPickupTask } from "../interfaces/delivery-company/tasks";
import { DataResources, ResourceActionType, user_has_data_model_access, user_is_admin } from "./permissions";

export const isFrozen = (task: IPickupTask): boolean => {
    
    return [PickupTaskState.COMPLETED, PickupTaskState.FAILED, PickupTaskState.CANCELLED].includes(task.status);
}

const taskHasStarted = (task: IPickupTask) => {
    return !([PickupTaskState.CREATED, PickupTaskState.ASSIGNED].includes(task.status))
}

const taskIsClosed = (task: IPickupTask) => {
    return task.status == PickupTaskState.FAILED || task.status == PickupTaskState.CANCELLED || task.status == PickupTaskState.COMPLETED
}

export const canCancelPickupTask = (task: IPickupTask, user: User | null) => {
    if (!user) return false;

    if (isFrozen(task))
        return false;

    if ([PickupTaskState.CANCELLED, PickupTaskState.COMPLETED, PickupTaskState.FAILED].includes(task.status))
        return false;


    if (task.status == PickupTaskState.PICKED_UP)
        return user_is_admin(user)

    return user.type == UserType.MERCHANT ||  user_has_data_model_access(user, DataResources.PICKUP_TASK, ResourceActionType.DELETE)
}

export const canCompletePickupTask = (task: IPickupTask, user: User | null) => {
    if (isFrozen(task))
        return false;

    return task.status === PickupTaskState.PICKED_UP
}

export const canChangePickupTaskDriver = (task: IPickupTask, user: User | null) => {
    if (isFrozen(task))
        return false;

    return !taskIsClosed(task) 
}

export const canRemoveOrdersFromTask = (task: IPickupTask, user: User | null) => {
    if (isFrozen(task))
        return false;

    // orders can be removed if the task hasn't started yet or orders are not yet picked up
    if (!taskHasStarted(task) || task.status === PickupTaskState.IN_PROGRESS) {
        // we can remove orders since the task didn't start yet
        return true
    }

    if (task.status === PickupTaskState.PICKED_UP) {
        // If orders are picked up, only the admin can remove an order from the task
        return user_is_admin(user)
    }

    // in all other cases, not allowed
    return false;
}

export const PickupTaskQRCodePrefix = "2"

export const pickupTaskToQRcodeID = (task: IPickupTask): string => {
    return `${PickupTaskQRCodePrefix}${task.id}`
}